module.exports = __webpack_public_path__ + "static/media/ketoemagtramina-5.d0b4555c.png";